import type { GroupingModel } from './types';

/** Account grouping is handled at the hierarchy layer; path methods already prefix when groupByAccount is set. */
export function withAccountGrouping(model: GroupingModel): GroupingModel {
  return model;
}
